import axios from "axios";

import { set401Modal, setNetworkErrorModal } from "@/redux/auth";
import { store } from "@/redux/store";

/*
 * Global 401 error handler
 * this is an api interceptor to handle 401 errors globally by doing this we can avoid writing 401 error handling in every component
 * this is used in App.tsx
 */

let isInterceptorSetup = false;
let interceptorId: null | number = null;

export const setupAxiosInterceptor = () => {
  if (isInterceptorSetup) {
    console.log("⚠️ Interceptor already setup, skipping");
    return;
  }
  interceptorId = axios.interceptors.response.use(
    (response) => {
      if (
        response.data?.status_code === 401 &&
        !response.config.url?.includes("/logout")
      ) {
        // Dispatch the 401 modal action
        store.dispatch(set401Modal());
      }

      return response;
    },
    (error) => {
      // Detect network failure (no internet, DNS issue, CORS, etc.)
      const isNetworkError =
        error.message?.includes("ERR_NETWORK") ||
        error.message?.includes("ERR_INTERNET_DISCONNECTED") ||
        error.message?.includes("Failed to fetch") ||
        error.code === "ERR_NETWORK" ||
        error.code === "ECONNABORTED";

      if (isNetworkError) {
        store.dispatch(setNetworkErrorModal());
        console.error("Detected network error:", error.message);
      }

      return Promise.reject(error);
    }
  );
  isInterceptorSetup = true;
  console.log("✅ Interceptor registered with ID:", interceptorId);
};

export const clearInterceptor = () => {
  if (interceptorId) {
    axios.interceptors.response.eject(interceptorId);
    console.log("✅ Interceptor cleaned with ID:", interceptorId);
  }
};

setupAxiosInterceptor();
